<div class="section">

    <!-- header section -->
    <div class="header-container">
        <div class="col-lg-12 col-md-12 col-sm-12 pad0 row">
            <div class="col-lg-4 col-md-4 col-sm-4 padL10">
                <div class="admin-name">Administrating Discrepancies</div>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 pad0" align="right">
                <div class="navItems">
                    <span class="headerLink">
                        <a routerLink="/search-discrep" routerLinkActive="active" class="navLink">DISCREPANCY
                            SEARCH</a>
                    </span>
                    <span class="headerLogoutLink">
                        <a class="navLink" (click)="logout()">LOGOUT</a>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <hr>

    <!-- Alert Message -->
    <div class="alert alert-warning" role="alert" *ngIf="alertMsg">{{alertMsg}}</div>
    <div class="alert alert-warning" role="alert" *ngIf="ifSplAlertMsg">{{searchNotAllowMsg}}</div>
    <div class="col-lg-12 col-md-12 col-sm-12 header-div mar-B10 row">
        <div class="col-lg-6 col-md-6 col-sm-6 padL10 " align="left">
            <span class="head-style">Discrepancy Search</span>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 padL10" align="right">
            <a class="navLink" (click)="exportToCSV()">
            <i class="pi pi-download" style="font-size: 1.3rem; color:blue"></i>&nbsp;&nbsp;
            Export Records</a>
        </div>
    </div>
    <div class="row">
        <div class="col-md-3 col-sm-3 search-container padL10">
            <!-- <div >SEARCH TYPE</div> -->
            <div>
                <div class="panel" *ngFor="let panel of panels">
                    <button class="panelBtn" (click)="togglePanel(panel)">
                        <span>{{panel.title}}</span>
                        <span class="toggle-icon" [class.open]="panel.isOpen"></span>
                    </button>
                    <p *ngIf="panel.isOpen">
                        <input type="text" *ngIf="panel.title !='DATE RANGE SEARCH'" class="form-control"
                            [ngStyle]="{'border': searchNotAllow ? '1px solid red' : '1px solid #ccc'  }"
                            (keypress)="onKeyPressEvent($event)" placeholder="Type here..."
                            [(ngModel)]="panel.searchText" />
                        <p-calendar *ngIf="panel.title =='DATE RANGE SEARCH'" placeholder="Select Date Range"
                            selectionMode="range" dateFormat="mm/dd/yy" [(ngModel)]="panel.rangeDates"
                            [readonlyInput]="true"></p-calendar>
                    </p>
                </div>
    
    
                <div class="mar-T10" align="center">
                    <button type="button" class="btn DR_Dt_btn btn-blue-cls" (click)="applySearch()">APPLY</button>
                </div>
            </div>
    
            <div class="searchType mar-T10">FILTER BY</div>
            <div>
                <span><input type="radio" name="filter" value=0 (change)="onFilterChange(0)"
                        [checked]="selectedFilter ==0">&nbsp;&nbsp;ALL</span><br>
                <span><input type="radio" name="filter" value=1 (change)="onFilterChange(1)"
                        [checked]="selectedFilter ==1">&nbsp;&nbsp;WAITING</span><br>
                <span><input type="radio" name="filter" value=2 (change)="onFilterChange(2)"
                        [checked]="selectedFilter ==2">&nbsp;&nbsp;NOTIFIED</span><br>
                <span><input type="radio" name="filter" value=3 (change)="onFilterChange(3)"
                        [checked]="selectedFilter ==3">&nbsp;&nbsp;CLOSED</span><br>
            </div>
            <div class="mar-T10" align="center">
                <button type="button" class="btn DR_Dt_btn btn-blue-cls" (click)="applyFilters()">APPLY</button>
            </div>
        </div>
        <div class="col-md-9 col-sm-9 table-container">
            <!-- client side pagination only -->
            <p-table id="AdminDiscData" [value]="discrepancyData"
                [paginator]="discrepancyData && discrepancyData.length > 10 ? true : false" [rows]="10"
                [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} / {totalRecords} rows"
                [(first)]="first" [tableStyle]="{'min-width': '50rem'}">
                <ng-template pTemplate="header">
                    <tr class="table-head">
                        <th id="disDisId">Discrepancy ID</th>
                        <th id="disPubNumb">Publication Number</th>
                        <th id="disAta">ATA</th>
                        <th id="disCurrentRev">Current Revision</th>
                        <th id="disOrg">Organization</th>
                        <th id="disPubType">Publication Type</th>
                        <th id="disPubStatus">Publication Status</th>
                        <th id="disLic">License</th>
                        <th id="disUserId">User <br>Id</th>
                        <th id="disDesStatus">Discrepancy Status</th>
                        <th id="disOpenDate">Open <br>Date</th>
                        <th id="disClosedDate">Closed <br>Date</th>
                        <th id="disDays">Days</th>
                        <th id="disCurDisCategory">Current Discrepancy Category</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-Discrepancy>
                    <tr class="table-td" *ngIf="ispubResults">
                        <td><a class="detailsALink"
                                (click)="discrepanyDetails(Discrepancy, 'E')">{{Discrepancy?.discid}}</a>
                        </td>
                        <td>{{Discrepancy?.pubnumber}}</td>
                        <td>{{Discrepancy?.atanumber}}</td>
                        <td>{{Discrepancy?.revnumber}}</td>
                        <td>{{Discrepancy?.organization}}</td>
                        <td>{{Discrepancy?.publicationtype}}</td>
                        <td>{{Discrepancy?.pubstatus}}</td>
                        <td>{{Discrepancy?.license}}</td>
                        <td>{{Discrepancy?.userid}}</td>
                        <td>{{Discrepancy?.drstatus}}</td>
                        <td>{{Discrepancy?.opendate}}</td>
                        <td>{{Discrepancy?.closeddate}}</td>
                        <td>{{Discrepancy?.days}}</td>
                        <td>{{Discrepancy?.currentdrcategory}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>